$(document).ready(function () {

    // WOW.js scroll animations
    new WOW().init({ offset: 20 });

    // Navbar collapse on link/button click (mobile)
    $(document).on('click.nav', '.navbar-collapse.in', function (e) {
        if ($(e.target).is('a') || $(e.target).is('button')) {
            $(this).collapse('hide');
        }
    });

    // Show more / about section toggle
    $("#show-btn").click(function () {
        $('#showme').slideDown("slow");
        $(this).hide();
        return false;
    });

    // Bootstrap carousel
    $('.carousel').carousel();

    // Bootstrap affix
    $('#modal-bar').affix({
        offset: { top: 10 }
    });

    // Smooth hash link scrolling
    $('.smooth-scroll').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 60
                }, 1000);
                return false;
            }
        }
    });

    // Project preview modal
    $('.img-box').click(function (e) {
        e.preventDefault();
        var elem = $(this).parent(),
            title = elem.find('.project-title').text(),
            price = elem.find('.project-price').text(),
            descr = elem.find('.project-description').html(),
            slidesHtml = '<div class="slides-container">',
            elemDataCont = elem.find('.project-description');
        var slides = elem.find('.project-description').data('images').split(',');
        for (var i = 0; i < slides.length; ++i) {
            slidesHtml = slidesHtml + '<img src=' + slides[i] + ' alt="">';
        }
        slidesHtml = slidesHtml + '</div><nav class="slides-navigation"><a href="#" class="next"><i class="icon-arrow-right"></i></a><a href="#" class="prev"><i class="icon-arrow-left"></i></a></nav>';
        $('#project-modal').on('show.bs.modal', function () {
            $(this).find('#sdbr-title').text(title);
            $(this).find('#sdbr-price').text(price);
            $(this).find('#project-content').html(descr).append('<a id="btn-order" class="btn btn-store btn-right" href="#">Order now</a>');
            $(this).find('.screen').addClass('slides').html(slidesHtml);
            if (elemDataCont.data('oldprice')) {
                $(this).find('#sdbr-oldprice').show().text(elemDataCont.data('oldprice'));
            } else {
                $(this).find('#sdbr-oldprice').hide();
            }
            if (elemDataCont.data('descr')) {
                $(this).find('#sdbr-descr').show().text(elemDataCont.data('descr'));
            } else {
                $(this).find('#sdbr-descr').hide();
            }
            setTimeout(function () {
                $('#project-modal .screen').addClass('done').prev('.loader').fadeOut();
            }, 1000);
        }).modal();
    });

    $('#project-modal').on('hidden.bs.modal', function () {
        $(this).find('.loader').show();
        $(this).find('.screen').removeClass('done').html('');
    });

    $('#project-modal').on('click', '#btn-order', function () {
        $('#project-modal').modal('hide');
        var aTag = $("section[id='orderform']");
        $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
    });
});
